import styled from "styled-components";

import marriageIcon from "../../assets/bride.png";
import confraternizationIcon from "../../assets/wedding-party.png";

export const Container = styled.header`
  width: 420px;
  height: 90px;
  margin: 30px 0px;
  padding: 18px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 0px 14px 4px var(--fair-pink);
  background-color: var(--black-pearl);

  @media screen and (max-width: 490px) {
    width: 350px;
    height: 80px;
  }

  @media screen and (max-width: 430px) {
    width: 310px;
  }

  @media screen and (max-width: 350px) {
    width: 290px;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;

  h1 {
    width: 100%;
    padding: 0 30px;
    font-weight: 100;
    text-align: left;
    text-shadow: 1px 1px 3px var(--fair-pink);
    font-size: 4rem;
    display: flex;
    flex-flow: row wrap;
    color: var(--fair-pink);

    @media screen and (max-width: 490px) {
      font-size: 3.5rem;
      padding: 0 6px;
    }

    @media screen and (max-width: 430px) {
      font-size: 3rem;
    }
  }

  div {
    width: 100%;
    height: 35px;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    align-items: center;

    a {
      padding: 4px 10px;
      margin: 10px;
      border-radius: 8px;
      color: var(--seal-brown);
      background-color: var(--snow-flurry);
      position: relative;
      top: -12px;

      svg {
        width: 40px;
        height: 30px;
        font-size: 1rem;
        color: var(--black-pearl);
      }

      @media screen and (max-width: 1000px) {
        font-size: 0.9rem;
      }

      @media screen and (max-width: 795px) {
        font-size: 0.8rem;
      }

      @media screen and (max-width: 490px) {
        font-size: 0.09rem;
      }

      @media screen and (max-width: 430px) {
        top: -3px;
      }
    }

    .amount {
      width: 178px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      position: relative;
      top: -39px;
      left: -30px;

      @media screen and (max-width: 430px) {
        top: -25px;
        left: ;
      }

      span {
        padding: 1px 3px;
        border-radius: 50%;
        font-size: 0.7rem;
        background-color: var(--soft-amber);
        color: var(--black-pearl);
        position: relative;
      }

      .marriage {
        left: -137px;
      }

      .confraternization {
        left: -70px;
      }

      .graduation {
        left: -3px;
      }
    }
  }
`;

export const IconMarriage = styled.img`
  background: url(${marriageIcon}) no-repeat center;
  background-size: contain;
  width: 40px;
  height: 30px;
`;

export const IconConfraternization = styled.img`
  background: url(${confraternizationIcon}) no-repeat center;
  background-size: contain;
  width: 40px;
  height: 30px;
`;
